<template>
	<div>
		<ul class="title1">
			<li class="L"><router-link to="/toutiao">中经头条</router-link></li>
			<li class="M"></li>
			<li class="R"><router-link to="/toutiao" class="more3">更多</router-link></li>
		</ul>
		<el-skeleton :rows="8" :loading="isloading" animated >
			<div class="headlines">
				<!-- headlines -->
				<div class="headlines_focus">
					<!-- headlines_img -->
					<!-- <div class="headline_tit" style="z-index: 3;"><a href=""></a></div> -->
					<!-- <div class="headline_more" title="详情"></div> -->
					<div class="headlines_img">
						<el-carousel trigger="click" height="240px" style="width: 480px;">
							<el-carousel-item v-for="(item,index) in toutiaoLeftList.data" :key="item.id" v-if="index<5">
								<a @click="jumppush('/detail/'+item.id+'/1?col=toutiao')">
								<div class="headline_txt" style="display: table; width: 480px; height: 93px;padding: 10px 20px;">
									<!-- <router-link :to="{ name: 'detail', params: { id: item.id , toutiaoflag:'1' }}"> -->
										<div style="display: table-cell;vertical-align: middle;">
											<h1 style="-webkit-line-clamp:2;">{{item.title}}</h1>
										</div>
									<!-- </router-link> -->
									<!-- <h2>{{item.summary}}</h2> -->
								</div>
								<img :src="toutiaoLeftList.images[item.id]" alt="" />
								</a>
							</el-carousel-item>
						</el-carousel>
					</div>
			
				</div><!-- /headlines_img -->
				<div class="headlines_list ">
					<!-- headlines_list-->
					<ul class="list1" style="margin-top: 8px;">
						<li v-for="(item,index) in toutiaoRightList" :key="item.id" v-if="index>4"><a @click="jumppush('/detail/'+item.id+'/1?col=toutiao')">{{item.title}}</a></li>
					</ul>
				</div><!-- /headlines_list -->
			</div><!-- /headlines -->
		</el-skeleton>
	</div>
	
</template>

<script>
	export default {
		data() {
			return {
				isloading:true,
				toutiaoLeftList: [],
				toutiaoRightList: [],
			}
		},
		created:function(){
			this.toutiaoleftfnc();
			// this.toutiaorightfnc();
		},
		computed: {

		},
		methods: {
			showLogin: function() {
				this.$emit('showLogin');
			},
			jumppush:function(to){
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					this.$cookies.set('fromdetail',to);
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			toutiaoleftfnc: function() {
				let _this = this;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'searchArticles',
						responseType: 'json',
						params: {
							columnID: '14f53ae655df407c8eff105594ae4c5e',
							isTopArticle: '1',
							iPage:'1',
							pageSize:'10',
						},
					})
					.then(function(response) {
						// console.log(response);
						// debugger;
						_this.toutiaoLeftList = response.data.data.data;
						_this.toutiaoRightList = response.data.data.data.data;
						_this.isloading=false;
					})
					.catch(function(error) {
						console.log(error);
					});;
			},
			toutiaorightfnc: function() {
				let _this = this;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'selectArticlesByRecommendTagID',
						responseType: 'json',
						params: {
							tagid: 'ecb509c8-bbd5-11ec-84ee-fefcfe218f7c',
							istop: '0',
						},
					})
					.then(function(response) {
						// console.log(response);
						// debugger;
						_this.toutiaoRightList = response.data.data.data;
					})
					.catch(function(error) {
						console.log(error);
					});;
			},
		}
	}
</script>

<style>
	.headlines_img .el-carousel__indicators--horizontal {
		bottom: unset;
		left: unset;
		top: 5%;
		right: 0;
	}

	.headlines_img .el-carousel__button {
		width: 8px;
		height: 8px;
	}
	
	/* .headlines .headlines_list .list1 li{
		line-height: 38px;
	} */
</style>
